// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(200%);
  background-color: #3a8073;
}

.loading {
  height: 65vh;
}

.equal-housing-icon {
  width: 80px;
}

.footer-text {
  font-size: 0.4em;
}

/* active label for inputs */

.input-control-group input:focus + .input-label,
.input-control-group select:focus + .input-label,
.input-control-group input:active + .input-label,
.input-control-group select:active + .input-label {
  color: #3a8073;
}

@media screen and (min-width: 1600px) {
  .wide-pricing {
    width: 66.666667%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/app.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;;AAC5B;;;;EAIE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".toggle__dot {\n  top: -0.25rem;\n  left: -0.25rem;\n  transition: all 0.3s ease-in-out;\n}\n\ninput:checked ~ .toggle__dot {\n  transform: translateX(200%);\n  background-color: #3a8073;\n}\n\n.loading {\n  height: 65vh;\n}\n\n.equal-housing-icon {\n  width: 80px;\n}\n\n.footer-text {\n  font-size: 0.4em;\n}\n\n/* active label for inputs */\n.input-control-group input:focus + .input-label,\n.input-control-group select:focus + .input-label,\n.input-control-group input:active + .input-label,\n.input-control-group select:active + .input-label {\n  color: #3a8073;\n}\n\n@media screen and (min-width: 1600px) {\n  .wide-pricing {\n    width: 66.666667%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
